import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {gsap} from "gsap";
import {DevilsCrossRoadFreespinReel} from "../../reelsfs/DevilsCrossRoadFreespinReel";
import {DevilsCrossRoad} from "../../DevilsCrossRoad";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {SimpleReelModelState} from "../../../core/reel/simplereel/SimpleReelModel";
import {DevilsCrossRoadGameConfig} from "../../DevilsCrossRoadGameConfig";
import {DevilsCrossRoadSound} from "../../sound/DevilsCrossRoadSound";
import {FreespinSymbol} from "../../reelsfs/FreespinSymbol";


export class  DevilsCrossRoadFreespinResult implements FlowStatePresentation {

    private lastReel:DevilsCrossRoadFreespinReel;
    private tl:gsap.core.Timeline = gsap.timeline();
    private isSkipped:boolean = false;
    private lastReelStopCall:boolean = false;
    private resultReelList: string [][] = [];
    private lastReelTl: gsap.core.Timeline | undefined;
    private stopTl: gsap.core.Timeline | undefined;
    private skippy:boolean = false;
    private slowMoTease:boolean = false;
    private slowMo:boolean = false;
    private slowMoDur:number = 0;


    start(flowStateController: FlowStateController): void {
        this.slowMoTease = false;
        this.slowMo = false;
        this.lastReelTl = undefined;
        this.lastReelStopCall = false;
        this.isSkipped = false;
        this.skippy = false;

        this.resultReelList.length = 0;

        this.tl = gsap.timeline();
        this.tl.timeScale(1);
        const stopTl = gsap.timeline();
        const minDelay = DevilsCrossRoad.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? DevilsCrossRoadGameConfig.FS_SYMBOL_DROP_FAST_SPIN_DELAY : DevilsCrossRoadGameConfig.FS_SYMBOL_DROP_DELAY

        const resultReelList: string [][] = [];
        const prevResultReelList: string [][] = [];

        const fakeReels: string [][] = [
            ["X","X","X","X","X","X"],
            ["X","X","X","X","X","X"],
            ["X","X","X","X","X","X"],
            ["X","X","X","X","X","X"],
            ["X","X","X","X","X","X"],
            ["X","X","X","X","X","X"]
        ];
        [0, 1, 2, 3, 4, 5].forEach((rowIndex) => {
            [0, 1, 2, 3, 4, 5].forEach((colIndex) => {
                // DevilsCrossRoad.model.gameData.stickyCoins[rowIndex][colIndex]
                resultReelList.push([DevilsCrossRoad.model.gameData.stickyCoins[rowIndex][colIndex]]);
                prevResultReelList.push([DevilsCrossRoad.model.gameData.previousStickyCoins[rowIndex][colIndex]]);
            });
        });

        for (let i:number = 0; i < DevilsCrossRoad.freespinReelAreaView.reels.length; i++) {
            for (let j:number = 0; j < DevilsCrossRoad.freespinReelAreaView.reels[i].length; j++) {
                DevilsCrossRoad.freespinReelAreaView.reels[i][j].model.resetGoatTls();
            }
        }

        let allSticky:boolean = true;
        let slowMoDur:number = 0;

        const fakeGoatRange: boolean = DevilsCrossRoad.model.isWithinRangeForGoatTease();
        let fakeGoatsAdded: number = 0;

        let lastSlowMoTease: boolean = false;


        let activeCount:number = 0;
        for (let i:number = 0; i < DevilsCrossRoad.freespinReelAreaView.reels.length; i++) {
            for (let j:number = 0; j < DevilsCrossRoad.freespinReelAreaView.reels[i].length; j++) {
                if (DevilsCrossRoad.freespinReelAreaView.reels[i][j].model.active){
                    const slowFakeRand: boolean = Math.round(Math.random() * 119) === 3;

                    // const slowFakeRand: boolean = Math.round(Math.random() * 11) === 3;
                    activeCount++;
                    this.lastReel = DevilsCrossRoad.freespinReelAreaView.reels[i][j];

                    if(DevilsCrossRoad.freespinReelAreaView.reels[i][j].model.state != SimpleReelModelState.STICKY) {
                        let slowMo:boolean = false;
                        let slowMoTease:boolean = false;

                        if(resultReelList[i][j] === "CX") {
                            this.slowMo = slowMo = true;
                            slowMoDur += this.slowMoDur = 0.8;
                            // TODO: Issue if last coin is CX, will not call finish()
                        }
                        else if(slowFakeRand && !lastSlowMoTease && fakeGoatRange && fakeGoatsAdded < 2 && resultReelList[i][j] === "X") {
                            this.slowMo = slowMo = true;
                            slowMoDur += this.slowMoDur =  0.8;
                            this.slowMoTease = slowMoTease = true;
                            //console.log("APPLIED GOAT TEASE!");
                            fakeGoatsAdded++;
                        }

                        // TODO: Add tracking of LAST slowMoTease
                        const lastWasSlowMo:boolean = !!(resultReelList[i - 1][j] && resultReelList[i - 1][j] === "CX" && DevilsCrossRoad.freespinReelAreaView.reels[i][j].model.state != SimpleReelModelState.STICKY);

                        stopTl.add([
                            DevilsCrossRoad.freespinReelAreaView.reels[i][j].model.stop([resultReelList[i][j]], undefined, undefined, slowMo, slowMoTease),

                            (slowMo || slowMoTease)? () => {
                                //this.tl.timeScale(1);
                           } : () => {}
                        ], (lastWasSlowMo || lastSlowMoTease)? `${minDelay * activeCount}` : `${(minDelay * activeCount) + slowMoDur}`) // `<${minDelay}0.1`
                        stopTl.add(()=>{
                            if (slowMo && !slowMoTease) {
                                let devilSym: FreespinSymbol = <FreespinSymbol>DevilsCrossRoad.freespinReelAreaView.reels[i][j].model.getVisibleSymbolAt(0).positionable;
                                if (devilSym.checkLineFilled()) {
                                    if (!DevilsCrossRoadSound.soundPlayer.fetchSoundPlayer(DevilsCrossRoadSound.FS_ROW_FILLED)?.isPlaying) {
                                        DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_ROW_FILLED});
                                    }
                                }
                            }
                        },">0.2");
                        lastSlowMoTease = slowMoTease;
                        if(slowMo || slowMoTease) {
                            stopTl.add(() => {

                                if(this.isSkipped) {
                                    this.tl.timeScale(6);
                                    if (DevilsCrossRoadSound.soundPlayer.fetchSoundPlayer(DevilsCrossRoadSound.FS_DEVIL_COIN_ANTICIPATION)?.isPlaying) {
                                        DevilsCrossRoadSound.soundPlayer.stopTrack(DevilsCrossRoadSound.FS_DEVIL_COIN_ANTICIPATION);
                                    }
                                }
                            });
                        }

                        slowMoDur = this.slowMoDur =  0;
                    }

                    // TODO: Make sure we only do this on the last sticky reel (according to reel stop order),
                        // TODO, Thius is probably the cause of reels not becoming sticky at certain situations (i.e. also on skip)
                    else {
                        //stopTl.add(this.skip(flowStateController),`<${minDelay}`);
                        stopTl.add([
                            DevilsCrossRoad.freespinReelAreaView.reels[i][j].model.stop([resultReelList[i][j]], undefined, true)
                        ], `+=${minDelay + this.slowMoDur}`);
                    }

                    allSticky = false;
                }
            }
        }

        this.tl.add(() => {
            if(!(DevilsCrossRoad.model.gameData.previousStickyCoins[4][5] !== "CX" && DevilsCrossRoad.model.gameData.stickyCoins[4][5] === "CX")) {
                flowStateController.setSkipCallback(() => this.skip(flowStateController));
            } else {
                flowStateController.setSkipCallback(() => this.specialSkip());
            }
        });

        if(!allSticky) {
            // TODO: Solve [["","","","","",""],["","","","X,X,X,CX","C",""],["","","","","",""],["","","","","",""],["","C","C","C","X,CX","C"],["","","","","",""]]
            this.lastReel.model.events?.once(SimpleReelModelState.STOPPED, () => this.lastReelStopped(flowStateController, resultReelList.length - this.lastReel.id, stopTl.totalDuration() - stopTl.totalTime()));
        }
        else {
            stopTl.add(() => {
                if(!this.lastReelStopCall) {
                    flowStateController.finish();
                    this.lastReelStopCall = true;
                }
            });
        }
        this.tl.add(stopTl);
    }

    private skip(flowStateController:FlowStateController):void {
        this.stopCoinAndReelSounds();

       /*if(DevilsCrossRoad.model.gameData.previousStickyCoins[4][5] !== "CX" && DevilsCrossRoad.model.gameData.stickyCoins[4][5] === "CX") {
            this.isSkipped = true;
            //debugger;
        }*/

        //this.isSkipped = true;

        if(this.slowMoTease || this.slowMo) {
            this.slowMoDur = 0;

            for (let i:number = 0; i < DevilsCrossRoad.freespinReelAreaView.reels.length; i++) {
                for (let j: number = 0; j < DevilsCrossRoad.freespinReelAreaView.reels[i].length; j++) {
                    for (let j: number = 0; j < DevilsCrossRoad.freespinReelAreaView.reels[i].length; j++) {
                        DevilsCrossRoad.freespinReelAreaView.reels[i][j].model.forceSkipGoat();
                    }
                }
            }

            this.tl.timeScale(6);
        }

        /*if(this.slowMoTease || this.slowMo) {

            for (let i:number = 0; i < DevilsCrossRoad.freespinReelAreaView.reels.length; i++) {
                for (let j: number = 0; j < DevilsCrossRoad.freespinReelAreaView.reels[i].length; j++) {
                    for (let j: number = 0; j < DevilsCrossRoad.freespinReelAreaView.reels[i].length; j++) {
                        DevilsCrossRoad.freespinReelAreaView.reels[i][j].model.forceSkipGoat();
                    }
                }
            }

            this.tl.progress(1);
            return this.tl; // TODO: As main tl is sequential and not async, we can allow skip even on slowmo cases.
        }*/

       //flowStateController.setSkipCallback();
        //this.isSkipped = true;

        if(!this.isSkipped) {
            const resultReelList: string [][] = [];

            [0, 1, 2, 3, 4, 5].forEach((rowIndex) => {
                [0, 1, 2, 3, 4, 5].forEach((colIndex) => {
                    // DevilsCrossRoad.model.gameData.stickyCoins[rowIndex][colIndex]
                    resultReelList.push([DevilsCrossRoad.model.gameData.stickyCoins[rowIndex][colIndex]]); // TODO: stickyCoins
                });
            });
            this.isSkipped = true;
            this.tl.progress(1);
        }

    }

    private specialSkip() {
        if(DevilsCrossRoad.model.gameData.previousStickyCoins[4][5] !== "CX" && DevilsCrossRoad.model.gameData.stickyCoins[4][5] === "CX") {
            this.tl.timeScale(15);
        }
    }

    private lastReelStopped(flowStateController:FlowStateController, indexDiffToLast:number, addDur:number = 0) {
        const tl:gsap.core.Timeline = gsap.timeline();
        //debugger;
        tl.add(()=>{
            DevilsCrossRoadSound.soundPlayer.stopTrack(DevilsCrossRoadSound.FS_REEL_SPIN_LOOP);
            DevilsCrossRoadSound.soundPlayer.playTrack({name:DevilsCrossRoadSound.FS_REEL_SPIN_STOP});

        },0);
        tl.add(()=>{
            if(!this.lastReelStopCall) {
                flowStateController.finish();
                this.lastReelStopCall = true;
            }
        },  0.1 + addDur); // 0.1 + (indexDiffToLast * 0.1) + addDur

        this.lastReelTl = tl;
        DevilsCrossRoadGameConfig.FS_PLAYED_REEL_LAND_SOUND = [false, false, false, false, false];
    }

    private stopCoinAndReelSounds():void{
        if (!DevilsCrossRoadSound.soundPlayer.fetchSoundPlayer(DevilsCrossRoadSound.FS_COIN_LAND1)?.isPlaying) {
            DevilsCrossRoadSound.soundPlayer.stopTrack(DevilsCrossRoadSound.FS_COIN_LAND1);
        } else if (!DevilsCrossRoadSound.soundPlayer.fetchSoundPlayer(DevilsCrossRoadSound.FS_COIN_LAND5)?.isPlaying) {
            DevilsCrossRoadSound.soundPlayer.stopTrack(DevilsCrossRoadSound.FS_COIN_LAND5);
        } else if (!DevilsCrossRoadSound.soundPlayer.fetchSoundPlayer(DevilsCrossRoadSound.FS_COIN_LAND20)?.isPlaying) {
            DevilsCrossRoadSound.soundPlayer.stopTrack(DevilsCrossRoadSound.FS_COIN_LAND20);
        } else if (!DevilsCrossRoadSound.soundPlayer.fetchSoundPlayer(DevilsCrossRoadSound.FS_COIN_LAND100)?.isPlaying) {
            DevilsCrossRoadSound.soundPlayer.stopTrack(DevilsCrossRoadSound.FS_COIN_LAND100);
        }
    }


}